var map = {
	"./add.svg": 970,
	"./align-center.svg": 971,
	"./align-left.svg": 972,
	"./align-right.svg": 973,
	"./arrow-down-asc.svg": 974,
	"./arrow-down-desc.svg": 975,
	"./arrow-down.svg": 976,
	"./arrow-up.svg": 977,
	"./base-module-drag.svg": 978,
	"./button-content.svg": 979,
	"./calendar-day.svg": 980,
	"./cancel.svg": 981,
	"./check.svg": 982,
	"./chevron-left.svg": 983,
	"./chevron-right.svg": 984,
	"./clone.svg": 985,
	"./close.svg": 986,
	"./code-transparent.svg": 987,
	"./code.svg": 988,
	"./collapse.svg": 989,
	"./content.svg": 990,
	"./context-menu.svg": 991,
	"./crop.svg": 992,
	"./delete.svg": 993,
	"./download.svg": 994,
	"./drag.svg": 995,
	"./duplicate.svg": 996,
	"./edit.svg": 997,
	"./expand.svg": 998,
	"./external-window.svg": 999,
	"./eye-slash.svg": 1000,
	"./eye.svg": 1001,
	"./file.svg": 1002,
	"./fill-blue.svg": 1003,
	"./filter.svg": 1004,
	"./first-page.svg": 1005,
	"./fit-blue.svg": 1006,
	"./folder-create.svg": 1007,
	"./folder.svg": 1008,
	"./google-maps.svg": 1009,
	"./grid-view.svg": 1010,
	"./hidden.svg": 1011,
	"./hyperlink.svg": 1012,
	"./image.svg": 1013,
	"./info.svg": 1014,
	"./internal-window.svg": 1015,
	"./last-page.svg": 1016,
	"./lock.svg": 1017,
	"./move-to.svg": 1018,
	"./move.svg": 1019,
	"./navigation.svg": 1020,
	"./next.svg": 1021,
	"./options.svg": 1022,
	"./page.svg": 1023,
	"./photo-library.svg": 1024,
	"./picture.svg": 1025,
	"./plus.svg": 1026,
	"./preferences.svg": 1027,
	"./prev.svg": 1028,
	"./radiobutton-off.svg": 1029,
	"./radiobutton-on.svg": 1030,
	"./refresh.svg": 1031,
	"./reset.svg": 1032,
	"./resize-vertical.svg": 1033,
	"./retoggle.svg": 1034,
	"./save.svg": 1035,
	"./search.svg": 1036,
	"./settings.svg": 1037,
	"./slider.svg": 1038,
	"./sort-alpha.svg": 1039,
	"./sort.svg": 1040,
	"./table-view.svg": 1041,
	"./text-left.svg": 1042,
	"./text.svg": 1043,
	"./title.svg": 1044,
	"./toggle.svg": 1045,
	"./trash.svg": 1046,
	"./unlock.svg": 1047,
	"./upload.svg": 1048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 969;